import React, { useEffect } from "react";
import { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import WithdrawDataTable from "./WithdrawDataTable.tsx";
import AutoCompleteMultiSelect from "../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import "./DialougeContent.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import Autocomplete from "@mui/material/Autocomplete";
import { ToastContainer, toast } from "react-toastify";

export default function WithdrawModalContent(props) {
  const apiAddress = process.env.REACT_APP_SECRET;
  const [restaurantDatas, setRestaurantDatas] = useState([]);
  const [restaurantAdded, setRestaurantAdded] = useState(null);
  const [withdrawType, setWithdrawType] = useState(null);
  const [withdrawTypes, setWithdrawTypes] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [widthDrawTableData, setWidthDrawTableData] = useState([]);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [totals, setTotals] = useState();
  const [hasAmount, setHasAmount] = useState(false);
  const [hasServiceCharge, setHasServiceCharge] = useState(false);
  const [hasTips, setHasTips] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  var [NoWithdrawableDataFound, setNoWithdrawableDataFound] = useState(false);
  const [needToAdjust, setNeedToAdjust] = useState([]);
  const [totalAmountToAdjust, setTotalAmountToAdjust] = useState(0);
  const [showNegetiveBalaceInfoModal, setShowNegetiveBalaceInfoModal] =
    useState(false);

  useEffect(() => {
    if (widthDrawTableData.length === 0) return;

    const adjustments = [];

    widthDrawTableData.forEach((item) => {
      const totalValues =
        (item.remainingServiceChargeVatAmount || 0) +
        (item.remainingServiceCharageAmount || 0) +
        (item.remainingTipsAmount || 0) +
        (item.totalRemainingAmount || 0);

      const totalTransactionFees = item.totalTransactionFees || 0;

      if (totalValues - totalTransactionFees < 0) {
        let paymentType = "";

        if (item.remainingServiceChargeVatAmount)
          paymentType += "ServiceChargeVat ";
        if (item.remainingServiceChargeAmount) paymentType += "ServiceCharge ";
        if (item.remainingTipsAmount) paymentType += "Tips ";
        if (item.totalRemainingAmount) paymentType += "Amount ";
        if (item.totalTransactionFees) paymentType += "TransactionFees ";

        paymentType = paymentType.trim();

        adjustments.push({ ...item, paymentType });
      }
    });

    setTotalAmountToAdjust(
      adjustments.reduce((acc, item) => {
        const totalValues =
          (item.remainingServiceChargeVatAmount || 0) +
          (item.remainingTipsAmount || 0) +
          (item.totalRemainingAmount || 0);

        const totalTransactionFees = item.totalTransactionFees || 0;

        const difference = totalValues - totalTransactionFees;

        return difference < 0 ? acc + Math.abs(difference) : acc;
      }, 0),
    );

    setNeedToAdjust(adjustments);

    if (adjustments.length > 0) {
      const cleaned = adjustments.map(
        ({ totalVat, totalSd, orderDate, ...rest }) => rest,
      );
      props.needToAdjust(cleaned);
    }
  }, [widthDrawTableData]);

  useEffect(() => {
    props.GetCalculatedTotal(totals);
  }, [totals]);

  useEffect(() => {
    // debugger
    // if (withdrawType !== null) {
    //     if (withdrawType?.id === 'WT001') {
    //         const filtered = withdrawTypes.filter(item => item.id === "WT001");
    //         setWithdrawType(filtered);
    //         props.getSelectedWithdrawTypes(filtered);
    //     }
    // }

    props.getSelectedWithdrawTypes(withdrawType);
  }, [withdrawType]);

  const loadData = async () => {
    const token = localStorage.getItem("gotasteadmintoken");
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);

        var obj = {
          id: decodedData.UserId,
          title: decodedData.UserName,
        };
      } catch (error) {}
    }
    const restaurant = JSON.parse(localStorage.getItem("restaurant"));
    try {
      await axios
        .get(
          apiAddress +
            "/api/Restaurant/getrestaurantdetailsbyidfortable/" +
            decodedData.UserId +
            "/" +
            restaurant.id,
        )
        .then((response) => {
          console.log(response.data);
          var list = [];
          // list.push(response.data)
          // setRestaurantDatas(list);
          response.data.map((dt, i) => {
            var obj = {
              id: dt.id,
              name: dt.name,
              address: dt.addressLine1,
              PhoneNumber: dt.phoneNumber,
              Email: dt.emailAddress,
              isActive: dt.isActive,
            };
            list.push(obj);
          });

          setRestaurantDatas(list);
        });
    } catch (error) {
      console.log("data fetching error");
    }
  };

  useEffect(() => {
    async function fetchData() {
      const response = await loadData();
    }
    fetchData();
  }, []);

  const FindResponse = async () => {
    setNoWithdrawableDataFound(false);
    setWidthDrawTableData([]);
    if (restaurantAdded?.length === 0 || !fromDate || !toDate) {
      toast.info("Please select a restaurant and dates");
      return;
    }

    const payload = {
      restaurantId: restaurantAdded?.id,
      fromDate,
      toDate,
    };

    try {
      const response = await axios.get(
        apiAddress + "/api/RestaurantBankDetails/GetWithdrawData",
        { params: payload },
      );

      setWidthDrawTableData(response.data);
    } catch (error) {
      toast.warning("No withdrawal data found for the given parameters.");
      setNoWithdrawableDataFound(true);
    }
  };

  useEffect(() => {
    if (restaurantAdded?.length !== 0 && fromDate !== "" && toDate !== "") {
      FindResponse();
    }
  }, [props.withdrawOnClick]);

  const GetAllWithdrawTypes = async () => {
    const token = localStorage.getItem("gotasteadmintoken");

    var decodedData = {};

    if (token != null) {
      try {
        decodedData = jwt_decode(token);

        var obj = {
          id: decodedData.UserId,
          title: decodedData.UserName,
        };
      } catch (error) {}
    }

    const restaurant = JSON.parse(localStorage.getItem("restaurant"));

    try {
      await axios
        .get(apiAddress + "/api/RestaurantBankDetails/GetAllWithdrawTypes")
        .then((response) => {
          setWithdrawTypes(response.data);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await GetAllWithdrawTypes();
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (withdrawType !== null && restaurantAdded?.length !== 0) {
      props.setRestaurantSelected(true);
    } else {
      props.setRestaurantSelected(false);
    }
  }, [withdrawType, restaurantAdded]);

  useEffect(() => {
    if (withdrawType !== null) {
      setHasAmount(withdrawType?.id === "WT001");
      setHasServiceCharge(withdrawType?.id === "WT003");
      setHasTips(withdrawType?.id === "WT002");
    }
  }, [withdrawType]);

  const handleSelectedOrder = (orders) => {
    setSelectedOrders(orders);
    const tempTotals = orders.reduce(
      (acc, curr) => {
        acc.totalRemainingAmount +=
          curr.totalRemainingAmount - curr.totalTransactionFees;
        acc.remainingTipsAmount += curr.remainingTipsAmount;
        acc.remainingServiceChargeAmount += curr.remainingServiceChargeAmount;
        acc.remainingServiceChargeVatAmount +=
          curr.remainingServiceChargeVatAmount;
        return acc;
      },
      {
        totalRemainingAmount: 0,
        remainingTipsAmount: 0,
        remainingServiceChargeAmount: 0,
        remainingServiceChargeVatAmount: 0,
      },
    );
    setTotals(tempTotals);
  };

  useEffect(() => {
    props.getSelectedOrders(selectedOrders);
  }, [selectedOrders]);

  const handleInputChange = (e) => {
    setSearchValue(e.target.value);
  };

  const searchingOnOrders = () => {
    if (searchValue !== "") {
      const filteredData = widthDrawTableData.filter((item) =>
        item.id.toLowerCase().includes(searchValue.toLowerCase()),
      );

      // setTableData(filteredData);
    } else {
      // setTableData(TableDataAll);
    }
  };

  return (
    <div className="withdraw-main-container">
      <ToastContainer />

      {/* Restaurant, WithDraw Type, to date, from-date */}
      <div className="d-flex justify-content-between align-items-center gap-3 flex-wrap mx-4 my-3">
        {/* Restaurant */}
        <div className="restaurant-withdraw">
          {/* <Typography className="withdraw-caption">Restaurant</Typography> */}
          <div className="withdraw-field">
            <div>
              <Autocomplete
                id="tags-outlined"
                clearText="clear"
                options={restaurantDatas}
                getOptionLabel={(option) => option.name}
                // onChange={(value) => { props.value(value); console.log(value) }}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                filterSelectedOptions
                onChange={(event, newInputValue) => {
                  setRestaurantAdded(newInputValue);
                  props.GetSelectedRestaurant(newInputValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={"Select Restaurants"}
                    placeholder={"Restaurants"}
                    required={true}
                  />
                )}
                value={restaurantAdded}
                // multiple={!props.val.some((item) => item.id === 28 && item.isOpen === true)}
                multiple={false}
              />
            </div>
          </div>
        </div>

        {/* WithDraw Type */}
        <div className="withdraw-type">
          {/* <Typography className="withdraw-caption">Withdraw Type</Typography> */}
          <div className="withdraw-field">
            <Autocomplete
              multiple={false}
              options={withdrawTypes || []}
              value={withdrawType || null}
              onChange={(event, newValue) => {
                setWithdrawType(newValue);
              }}
              getOptionLabel={(option) => option?.title || ""}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              filterSelectedOptions
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Withdrawal Type"
                  placeholder="Select withdrawal type"
                />
              )}
            />
          </div>
        </div>

        {/* From Date */}
        <div className="withdraw-from-date">
          <TextField
            className="withdraw-field"
            fullWidth
            label="From Date"
            type="date"
            value={fromDate}
            onChange={(e) => {
              const selectedDate = e.target.value;
              const today = new Date().toISOString().split("T")[0];

              if (selectedDate > today) {
                toast.error("From Date cannot be in the future");
                return;
              }

              if (toDate && selectedDate > toDate) {
                toast.error("From Date cannot be after To Date");
                return;
              }

              setFromDate(selectedDate);
            }}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              max: toDate || new Date().toISOString().split("T")[0],
            }}
          />
        </div>

        {/* To Date */}
        <div className="withdraw-to-date">
          <TextField
            label="To Date"
            fullWidth
            type="date"
            className="withdraw-field"
            value={toDate}
            onChange={(e) => {
              const selectedDate = e.target.value;
              const today = new Date().toISOString().split("T")[0];

              if (selectedDate > today) {
                toast.error("To Date must be today or earlier");
                return;
              }

              if (fromDate && selectedDate < fromDate) {
                toast.error("To Date cannot be before From Date");
                return;
              }

              setToDate(selectedDate);
            }}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              max: new Date().toISOString().split("T")[0], // ✅ ensures To Date ≤ today
              min: fromDate || undefined,
            }}
          />
        </div>

        {/* Find Button */}
        <div className="withdraw-find-button">
          <Button variant="contained" onClick={FindResponse}>
            Find
          </Button>
        </div>
      </div>

      {/* Need To Adjust Section */}
      {needToAdjust.length > 0 && (
        <div
          style={{ cursor: "pointer", marginLeft: "8px" }}
          role="alert"
          onClick={(e) => {
            e.stopPropagation();
            setShowNegetiveBalaceInfoModal(true);
          }}
        >
          <Button
            size="small"
            style={{
              marginLeft: 8,
              minWidth: 0,
              padding: 4,
              background: "transparent",
              color: "#1976d2",
              fontSize: 18,
              lineHeight: 1,
            }}
            aria-label="Info"
          >
            ℹ️
          </Button>
          <span style={{ textDecoration: "underline" }}>
            Some orders have less than transaction fees. Click to Review order
            details.
          </span>
        </div>
      )}

      {totals && (
        <div className="d-flex gap-3 flex-row mx-4 my-3 flex-wrap">
          {/* Search Fields */}
          {/* <div className="orderHistoryLogSearchBox">
                        <input type="text" placeholder="Search by id" onChange={handleInputChange} value={searchValue} />
                        <button onClick={searchingOnOrders}>Search</button>
                    </div> */}
          <div className="d-flex flex-column gap-1">
            {/* Total Amounts */}
            <div
              className="withdraw-modal-card"
              style={{
                background:
                  withdrawType?.id === "WT001" ? "#e0f7fa" : "transparent",
              }}
            >
              <Typography>
                £{hasAmount ? totals.totalRemainingAmount.toFixed(2) : 0}
              </Typography>
              <h6>Full Amounts </h6>
              <span className="text-muted" style={{ fontSize: "10px" }}>
                {" "}
                (Inc. Tips and Service Charge - transaction fees)
              </span>
            </div>

            {/* Total Amount to Adjust */}
            <div
              className="withdraw-modal-card"
              style={{
                background: totalAmountToAdjust > 0 ? "#ffebee" : "transparent",
                width: "220px",
              }}
            >
              <Typography>- £{totalAmountToAdjust.toFixed(2)}</Typography>
              <Typography>Unpaid Fees</Typography>
            </div>
          </div>

          <div className="d-flex flex-column gap-1">
            {/* Total Tips */}
            <div
              className="withdraw-modal-card"
              style={{
                background:
                  withdrawType?.id === "WT002" || withdrawType?.id === "WT001"
                    ? "#e0f7fa"
                    : "transparent",
              }}
            >
              <Typography>
                £{hasTips ? totals.remainingTipsAmount.toFixed(2) : 0}
              </Typography>
              <h6>Total Tips</h6>
            </div>

            {/* Withdraw Fees */}
            <div className="withdraw-modal-card">
              <Typography>- £0.00</Typography>
              <Typography>Withdrawal Fees</Typography>
            </div>
          </div>
          <div className="d-flex flex-column gap-1">
            <div>
              {/* Total Service Charge */}
              <div
                className="withdraw-modal-card"
                style={{
                  background:
                    withdrawType?.id === "WT003" || withdrawType?.id === "WT001"
                      ? "#e0f7fa"
                      : "transparent",
                  width: "172px",
                }}
              >
                <Typography>
                  £
                  {hasServiceCharge
                    ? (
                        totals.remainingServiceChargeAmount +
                        totals.remainingServiceChargeVatAmount
                      ).toFixed(2)
                    : 0}
                </Typography>
                <h6>Total Service Charge</h6>
                <span className="text-muted" style={{ fontSize: "10px" }}>
                  {" "}
                  (Inc. Service Charge Vat)
                </span>
              </div>
            </div>
            {/* Withdrawable Amount */}
            <div className="withdraw-modal-card">
              {/* {hasTips ? "true" : "false"}
              {JSON.stringify(withdrawType)} */}
              <Typography>
                {selectedOrders.length > 0
                  ? (() => {
                      switch (true) {
                        case hasAmount:
                          return `£${(
                            totals.totalRemainingAmount -
                            0.0 - // withdraw fees
                            totalAmountToAdjust
                          ).toFixed(2)}`;
                        case hasTips:
                          return `£${(
                            totals.remainingTipsAmount -
                            0.0 - // withdraw fees
                            totalAmountToAdjust
                          ).toFixed(2)}`;
                        case hasServiceCharge:
                          return `£${(
                            totals.remainingServiceChargeAmount +
                            totals.remainingServiceChargeVatAmount -
                            0.0 - // withdraw fees
                            totalAmountToAdjust
                          ).toFixed(2)}`;
                        default:
                          return "£0.00";
                      }
                    })()
                  : "£0.00"}
              </Typography>
              <Typography>Withdrawable Amount</Typography>
            </div>
          </div>

          {/* Pricing Breakdown */}
          <div className="withdraw-modal-card-ex">
            <Typography style={{ textDecoration: "underline" }}>
              {" "}
              Pricing Breakdown{" "}
            </Typography>
          </div>
        </div>
      )}

      <div style={{ marginLeft: "20px" }}>
        {!hasAmount && !hasTips && !hasServiceCharge && (
          <span className="text-muted text-decoration-underline">
            Note: To calculate select withdraw types
          </span>
        )}
      </div>

      {/* Data Table */}
      <div style={{ width: "100%" }}>
        {widthDrawTableData.length > 0 && (
          <>
            <WithdrawDataTable
              tableData={widthDrawTableData}
              selectOrder={handleSelectedOrder}
            />
          </>
        )}

        {NoWithdrawableDataFound && (
          <p style={{ textAlign: "center" }}>
            No withdrawal data found for the given parameters.
          </p>
        )}
      </div>

      {/* Negetive Balance Info Modal */}
      {showNegetiveBalaceInfoModal && needToAdjust.length > 0 && (
        <div className="nevative-balance-info">
          <Button
            onClick={() => setShowNegetiveBalaceInfoModal(false)}
            style={{
              position: "absolute",
              top: 0,
              right: 8,
              minWidth: 0,
              padding: 4,
              background: "transparent",
              color: "#ffffffff",
              fontSize: 20,
              zIndex: 2,
            }}
            aria-label="Close"
          >
            &times;
          </Button>
          {needToAdjust.map((item) => (
            <div key={item.id} style={{ marginBottom: "5px" }}>
              <span style={{ textDecoration: "underline" }}>
                Order ID: # {item?.id?.slice(-6)}
              </span>{" "}
              <br />
              Total Amount: £{item.totalRemainingAmount?.toFixed(2)}, <br />
              Total Tips : £{item.remainingTipsAmount?.toFixed(2)}, <br />
              Total Service Charge: £
              {item.remainingServiceChargeAmount?.toFixed(2)}, <br />
              Total Service Charge Vat: £
              {item.remainingServiceChargeVatAmount?.toFixed(2)}, <br />
              Total Transaction Fees: £{item.totalTransactionFees?.toFixed(
                2,
              )}, <br />
              Withdrawable Amount: £
              {(
                item.totalRemainingAmount +
                item.remainingTipsAmount +
                item.remainingServiceChargeVatAmount -
                item.totalTransactionFees
              )?.toFixed(2)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
